module.exports = __webpack_public_path__ + "media/images/InitativeOrganisation-75e059383f4c3ee455dc902406d9cb13.svg";